<template>
  <TheModal v-if="isShow"
    id="tour-modal"
    :close-overlay="false"
    :show-header="false"
    @close="close">
    <div class="tour-top-wrapper">
      <swiper
        ref="swiperTop"
        :options="swiperOptionTop"
        class="swiper tour-top"
        @slideChange="handleSlideChange">
        <swiper-slide
          v-for="(item, index) in tour"
          :key="index"
          class="slide-image">
          <img
            :src="item.image"
            :alt="item.title"
            :title="item.title"
            loading="lazy">
        </swiper-slide>
      </swiper>
    </div>

    <div class="tour-bottom-wrapper">
      <swiper
        ref="swiperBottom"
        :options="swiperOptionBottom"
        class="swiper tour-bottom">
        <swiper-slide
          v-for="(item, index) in tour"
          :key="index"
          class="slide-text">
          <h5>{{ item.title }}</h5>
          <p>{{ item.description }}</p>
        </swiper-slide>
        <div class="swiper-pagination" slot="pagination"></div>
      </swiper>
    </div>

    <template slot="footer">
      <div>
        <template v-if="tour.length > 1">
          <button
            type="button"
            class="button-prev btn btn-primary"
            :disabled="disabled.back"
            slot="button-prev">
            Back
          </button>
          <button
            type="button"
            class="button-next btn btn-primary"
            :disabled="disabled.next"
            slot="button-next">
            Next
          </button>
        </template>
      </div>
      <button
        type="button"
        class="btn btn-outline-primary"
        @click="setDone">
        Finish
      </button>
    </template>
  </TheModal>
</template>

<script>
export default {
  name: 'HomeTour',

  data() {
    return {
      isShow: false,

      disabled: {
        next: false,
        back: true,
      },

      swiperOptionTop: {
        loop: false,
        loopedSlides: 1,
      },

      swiperOptionBottom: {
        loop: false,
        loopedSlides: 1,
        slidesPerView: 1,
        touchRatio: 0.2,
        slideToClickedSlide: true,
        effect: 'fade',
        fadeEffect: {
          crossFade: true,
        },
        navigation: {
          nextEl: '.button-next',
          prevEl: '.button-prev',
        },
        pagination: {
          el: '.swiper-pagination',
          clickable: true,
        },
      },

      tour: [
        {
          title: 'Consectetur Adipiscing Elit',
          image: 'https://via.placeholder.com/640x400',
          description: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Vestibulum hendrerit viverra lorem, rhoncus iaculis diam pellentesque porttitor. Aliquam at dui cursus, aliquam elit in, ornare dolor.',
        },
        {
          title: 'Integer Rhoncus Neque',
          image: 'https://via.placeholder.com/640x400',
          description: 'Integer rhoncus neque neque. Sed dapibus mi non cursus commodo. Donec dictum massa a purus venenatis, at malesuada dui convallis.',
        },
        {
          title: 'Ut Viverra Odio',
          image: 'https://via.placeholder.com/640x400',
          description: 'Ut viverra odio ut neque vulputate consequat. Proin pharetra risus sagittis lectus ornare, vitae ullamcorper tellus laoreet. Ut commodo hendrerit ex, ut lobortis mi pellentesque et.',
        },
        {
          title: 'Vivamus Condimentum',
          image: 'https://via.placeholder.com/640x400',
          description: 'Vivamus condimentum enim in diam porttitor, ac luctus magna vehicula. Proin vel euismod eros. Sed facilisis magna ipsum, efficitur fermentum diam fringilla non.',
        },
        {
          title: 'Vestibulum Tincidunt Tellus',
          image: 'https://via.placeholder.com/640x400',
          description: 'Vestibulum tincidunt tellus risus, in dignissim orci rhoncus ullamcorper. Aenean scelerisque congue magna at vulputate. Sed quis erat malesuada, tincidunt lacus et, lacinia arcu.',
        },
      ],
    };
  },

  mounted() {
    this.init();
  },

  methods: {
    async init() {
      await this.checkCookie();
      this.tour = await this.fetchData();

      if (this.tour.length) {
        this.isShow = true;
        this.$nextTick(() => {
          this.setDisabled();
          this.initSwiper();
        });
      }
    },

    checkCookie() {
      return new Promise((resolve, reject) => {
        if (this.$cookies.get('pilihlaptop-tour')) {
          reject();
        } else {
          resolve();
        }
      });
    },

    fetchData() {
      return this.$mainApi.get('tour-guides')
        .then((res) => res.data.data.result);
    },

    setDisabled() {
      if (this.tour.length === 1) {
        this.disabled.back = true;
        this.disabled.next = true;
      }
    },

    initSwiper() {
      setTimeout(() => {
        this.$nextTick(() => {
          const swiperTop = this.$refs.swiperTop.$swiper;
          const swiperBottom = this.$refs.swiperBottom.$swiper;
          swiperTop.controller.control = swiperBottom;
          swiperBottom.controller.control = swiperTop;
        });
      }, 500);
    },

    handleSlideChange() {
      const index = this.$refs.swiperTop.$swiper.activeIndex;
      const tourLength = this.tour.length - 1;

      if ((index !== 0) || (index !== tourLength)) {
        this.disabled.back = false;
        this.disabled.next = false;
      }

      if (index === 0) {
        this.disabled.back = true;
      }

      if (index === tourLength) {
        this.disabled.next = true;
      }
    },

    setDone() {
      this.$cookies.set('pilihlaptop-tour', 'true', '1d');
      this.close();
    },

    close() {
      this.isShow = false;
    },
  },
};
</script>

<style lang="scss">
  #tour-modal {
    .modal-body {
      padding: 0;
    }

    .modal-footer {
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding: 1rem 1.5rem;
      border-top: none;

      .btn {
        min-width: 6rem;

        + .btn {
          margin-left: 0.5rem;
        }
      }
    }

    .tour-top-wrapper {
      min-height: 400px;

      img {
        height: 400px;
        width: 100%;
        object-fit: contain;
      }
    }

    .tour-bottom-wrapper {
      padding: 1rem 1.5rem;

      h5 {
        font-weight: 600;
        font-size: 1.125rem;
      }

      p {
        font-size: 0.875rem;
      }

      .swiper-container {
        padding-top: 3rem;
      }

      .swiper-pagination {
        text-align: left;
        left: 0;
        top: 0;
        bottom: auto;

        .swiper-pagination-bullet {
          background: $grey-medium;
          border-radius: 0.25rem;
          width: 0.5rem;
          transition: all 0.3s ease;

          &:hover {
            opacity: 1;
            background: $color-primary;
          }
        }

        .swiper-pagination-bullet-active {
          width: 2rem;
          background: $color-primary;
        }
      }
    }
  }
</style>
